import { useState } from "react";
import { collectionRef } from "@/api/firebase/collectionOperations";
import { useCurrentUserProfile } from "@/store/auth/userProfile.store";
import { Job } from "@/models/Job.model";

export const useUpdateJob = (id: string) => {
  const user = useCurrentUserProfile((s) => s.user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const updateJobListing = async (job: Job) => {
    if (!user) {
      setError(new Error("User not authenticated"));
      return;
    }

    setLoading(true);
    try {
      await collectionRef.Jobs.doc(id).update({
        ...job,
      });
      setLoading(false);
    } catch (error) {
      setError(error as Error);
      setLoading(false);
    }
  };

  return { updateJobListing, loading, error };
};
